<template>
  <path pid="0" d="M7 16.85zM21 4a1 1 0 00-1 1v7.18A3 3 0 0117 15H7.41l3.3-3.29a1 1 0 00-1.42-1.42l-5 5-.08.1-.06.09V15.65a.25.25 0 000 .07.13.13 0 010 .06V16a.76.76 0 000 .15v.05a.25.25 0 000 .07v.06a.17.17 0 010 .05v.06a.35.35 0 000 .08l.07.08 5 5a1 1 0 001.42 0l.08-.1a1 1 0 00-.08-1.32L7.41 17H17a5 5 0 005-5V5a1 1 0 00-1-1z"/>
</template>
